export function Spinner({ size = 14 }: { size?: number }) {
  return (
    <svg
      className="rt-spin"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      aria-label="Загрузка"
    >
      <circle
        cx="8" cy="8" r="6.5" fill="none"
        stroke="var(--rt-line)" strokeWidth="2"
      />
      <path
        d="M8 1.5a6.5 6.5 0 0 1 6.5 6.5" fill="none"
        stroke="var(--rt-acc)" strokeWidth="2" strokeLinecap="square"
      />
    </svg>
  );
}
